<template>
  <div class="loading-container">
    <div class="content d-flex ">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="loader-content d-flex flex-column justify-content-center">
        <p>{{ loaderTitle }}</p>
        <span v-if="loaderBody" class="count">as{{ loaderBody }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Timesheet",
  props: {
    loaderTitle: {
      type: String,
      default: "Loading data",
    },
    loaderBody: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  position: absolute;
  width: 100vw;
  height: 100%;
  inset-inline-start: 0px;
  top: 0px;
  z-index: 9999;
  background: rgba($color: #000000, $alpha: 0.5);

  .spinner-border {
    color: #103f5e;
    border-width: 0.35em;
    width: 38px;
    height: 38px;
    margin-inline-end: 22px;
    margin-inline-start: 31px;
    border-right-color: #d9d9d9;
  }
  .content {
    position: fixed;
    top: 40%;
    inset-inline-start: 40%;
    background-color: #ffffff;
    height: fit-content;
    width: fit-content;
    padding: 0;
    opacity: 1;
    padding-top: 22.5px;
    padding-inline-end: 32px;
    padding-bottom: 22.5px;
    padding-inline-start: 5px;
    border-radius: 50px;
  }
  p {
    font-weight: 700;
    font-size: 16px;
    line-height: 152%;
    color: #000000;
    padding: 0;
    margin: 0 !important;
  }
  span {
    font-weight: 600;
    color: #787878;
    font-size: 14px;
    line-height: 152%;
  }
}
</style>